import React, {FC, ReactElement, Suspense} from 'react';
import {Route as DOMRoute, RouteProps as DOMRouteProps} from 'react-router-dom';

interface RouteProps extends DOMRouteProps {
    component: any
}

const Route: FC<RouteProps> = ({component: Component, ...rest}): ReactElement => (
    <DOMRoute {...rest} render={matchProps => (
        <Suspense fallback={null}>
            <Component {...matchProps}/>
        </Suspense>
    )}>
    </DOMRoute>
);

export default Route;
